module.exports = __webpack_public_path__ + "img/25_10.4cfaad52.png";